var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendaricon = function SvgCalendaricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.013 2.247H.986v3.187h14.027zM15.013 5.434H.986V15h14.027zM3.533 8.62h1.28M6.086 8.62h1.273M8.64 8.62h1.274M11.188 8.62h1.28M11.188 11.814h1.28M3.533 11.814h1.28M6.086 11.814h1.273M8.64 11.814h1.274M4.174.333V3.52M8 .333V3.52M11.826.333V3.52"
  }))));
};
export default SvgCalendaricon;